import React from 'react';
import { Target, MessageSquare, Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function PerformanceWidget() {
  const navigate = useNavigate();
  return <div className="bg-white rounded-lg shadow-sm p-5 col-span-1 min-h-[400px] flex flex-col" data-id="element-2042">
      <div className="flex items-center justify-between mb-4" data-id="element-2043">
        <h3 className="font-semibold text-gray-900" data-id="element-2044">
          Performance & Développement
        </h3>
        <Target className="h-5 w-5 text-blue-600" data-id="element-2045" />
      </div>
      <div className="space-y-4 flex-1" data-id="element-2046">
        <div className="border-l-4 border-blue-500 pl-3 py-1" data-id="element-2047">
          <div className="flex justify-between items-start" data-id="element-2048">
            <div data-id="element-2049">
              <p className="font-medium text-gray-900" data-id="element-2050">Objectifs</p>
              <p className="text-sm text-gray-600" data-id="element-2051">3 objectifs actifs</p>
            </div>
            <span className="text-xs px-2 py-1 rounded-full bg-green-100 text-green-800" data-id="element-2052">
              75% complété
            </span>
          </div>
        </div>
        <div className="border-l-4 border-purple-500 pl-3 py-1" data-id="element-2053">
          <div className="flex justify-between items-start" data-id="element-2054">
            <div data-id="element-2055">
              <p className="font-medium text-gray-900" data-id="element-2056">Prochain 1:1</p>
              <div className="flex items-center text-sm text-gray-600" data-id="element-2057">
                <Calendar className="h-4 w-4 mr-1" data-id="element-2058" />
                <span data-id="element-2059">15 Dec 2023</span>
              </div>
            </div>
            <button onClick={() => navigate('/performance')} className="text-xs px-2 py-1 bg-blue-100 text-blue-800 rounded-full hover:bg-blue-200" data-id="element-2060">
              Préparer
            </button>
          </div>
        </div>
        <div className="border-l-4 border-yellow-500 pl-3 py-1" data-id="element-2061">
          <div className="flex justify-between items-start" data-id="element-2062">
            <div data-id="element-2063">
              <p className="font-medium text-gray-900" data-id="element-2064">Feedback reçu</p>
              <div className="flex items-center text-sm text-gray-600" data-id="element-2065">
                <MessageSquare className="h-4 w-4 mr-1" data-id="element-2066" />
                <span data-id="element-2067">2 nouveaux</span>
              </div>
            </div>
            <button onClick={() => navigate('/performance')} className="text-xs px-2 py-1 bg-blue-100 text-blue-800 rounded-full hover:bg-blue-200" data-id="element-2068">
              Voir
            </button>
          </div>
        </div>
      </div>
      <button onClick={() => navigate('/performance')} className="mt-4 w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium transition-colors duration-150 ease-in-out" data-id="element-2069">
        Accéder à mon espace performance
      </button>
    </div>;
}